export default {
  goodsStatusEnum: {
    '-1': 'Payment pending',
    0: 'Under review',
    1: 'Confirmation pending',
    2: 'Repayment pending',
    3: 'Return goods',
    4: 'Exchange goods',
    5: 'Seller sent',
    6: 'Separate shipment',
    7: 'Deferred processing',
    8: 'Delivered',
    9: 'Being stored',
    10: 'Stored',
    11: 'Invalid',
    12: 'Destroyed',
    13: 'Expired',
    14: 'Information confirmation',
    15: 'Purchase confirmation',
    16: 'Awaiting return process',
    17: 'Awaiting exchange process',
    18: 'Return processing',
    19: 'Exchange processing',
    20: 'Returned',
    21: 'Exchanged',
    22: 'Purchased',
    23: 'Processing',
    24: 'Cancelled',
    25: 'Abnormal order',
    26: 'Awaiting refund',
    27: 'Awaiting reshipment',
    28: 'Collecting',
    29: 'Packing completed',
    30: 'Sent internationally',
    31: 'Received',
    32: 'Order refused payment',
    33: 'Risk control',
    34: 'Refund completed',
    35: 'List of frozen orders',
    36: 'Pre-subscription payment',
    37: 'Awaiting collecting',
    38: 'Refund in progress',
    39: 'Rejected goods',
    40: 'Rejection completed',
    41: 'Exception not in stock',
    42: 'Exception in stock',
    43: 'Return cancelled',
    44: 'Exchange cancelled',
    45: 'Signed and pending',
    46: 'Order Processing',
    47: 'Order Processing',
    48: 'Payment completed',
    49: 'Abandoned',
    50: 'Completed',
    51: `Return awaiting seller's approval`,
    52: `Exchange awaiting seller's approval`,
    53: 'Returned package invalid',
    54: 'To be generated',
    55: 'Order Processing',
    58: 'Commodities in transfer',
    61: 'Order Processing',
    62: 'Order Processing',
  },
  appendStatusEnum: {
    0: 'Pending',
    1: 'Processing',
    2: 'Cancelled',
    3: 'Completed',
    4: 'Returned',
  },
  inviteStatusEnum: {
    0: 'Not Active',
    1: 'Active',
  },
}
